module.exports = __webpack_public_path__ + "img/hiv_status.81a981b9.jpg";